import { useMemo } from "react";

import NotesIcon from "@mui/icons-material/Notes";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";

import { take, truncate } from "lodash";

import { neutral } from "app/themes/colors";
import CircularProgress from "components/circular-progress";
import useSunoDialer from "components/suno-dialer/use-suno-dialer.hook";

export default function NotesBlock() {
  const theme = useTheme();

  const { activeCallDetails, patient, isLoading } = useSunoDialer();

  const lastNotes = useMemo(
    () => take(patient?.patient_notes || [], 3),
    [patient?.patient_notes]
  );

  if (!activeCallDetails?.callerId) return null;

  return (
    <Box sx={{ px: 2, pt: 2, pb: 0 }}>
      <Stack
        spacing={1.5}
        sx={{
          color: neutral[900],
          background: "hsla(50, 100%, 100%, 0.7)",
          px: 2,
          pt: 1,
          pb: 1,
          borderRadius: "8px",
          boxShadow: theme.shadows[3]
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Stack spacing={1} paddingRight={2} width="100%">
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 700,
                lineHeight: 1.3,
                pb: 0.25
              }}
            >
              Notes:
            </Typography>
            {isLoading ? (
              <CircularProgress sx={{ p: 0, transform: "translateY(-15px)" }} />
            ) : lastNotes?.length ? (
              lastNotes.map((note) => (
                <Typography
                  key={note.id}
                  sx={{
                    fontSize: "15px",
                    lineHeight: 1.3,
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }}
                >
                  <NotesIcon
                    sx={{ fontSize: "15px", transform: "translateY(1px)" }}
                  />{" "}
                  {note.title ? <b>{note.title}:</b> : ""}{" "}
                  {truncate(note.description, { length: 36 })}
                </Typography>
              ))
            ) : (
              <Typography
                sx={{
                  fontSize: "15px",
                  lineHeight: 1.3,
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }}
              >
                No notes found
              </Typography>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
}
